// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".linha-lida {\n\tfont-weight: bold;\n}", "",{"version":3,"sources":["webpack://src/pages/central/central.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;AAClB","sourcesContent":[".linha-lida {\n\tfont-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
